import { useNavigate } from "react-router";
import ModalSimple from "../../components/modal-simple";
import Button from "../../components/button";
import { HelpLink } from "../../common/help";

function DeviceFailPage() {
  const navigation = useNavigate();

  const accessibly = () => {
    navigation(`/`);
  }

  const help = () => {
    window.location.href = HelpLink;
  }

  return (
    <div className="buy-fail">
      <ModalSimple>
        <div>
        <h1>Ой-ой</h1>
          <div>
            <p>Из-за проблем с сервером сейчас<br/>добавить устройство не получится.<br/>Попробуйте позже</p>
          </div>
        </div>
        <Button label={"Понятно"} onClick={() => accessibly()}/>
        <Button label={"Поддержка"} variant={"secondary"} onClick={() => help()}/>
      </ModalSimple>
    </div>
  );
}

export default DeviceFailPage;